import React from 'react';
import FormInput from 'components/ui/v2/Inputs';
import { StyledCardNumberElement } from './styles';
import { StripeCardNumberElementChangeEvent } from '@stripe/stripe-js';
import { useAdminTranslation } from 'hooks/use-translation';
import useToggle from 'hooks/use-toggle';

type CardNumberProps = {
  error: string | undefined;
  onChange: (error: string | undefined, complete: boolean) => void;
};

const CardNumber: React.FC<CardNumberProps> = ({ onChange, error }) => {
  const { t } = useAdminTranslation();
  const [focused, toggle] = useToggle(false);
  const handleCardNumberChange = React.useCallback((event: StripeCardNumberElementChangeEvent) => {
    onChange(event.error?.message, event.complete);
  }, [onChange]);

  return (
    <FormInput.Root error={!!error}>
      <FormInput.FieldSet focused={focused}>
        <FormInput.Legend>{t('CREDIT_CARD_NUMBER')}</FormInput.Legend>
        <FormInput.InputIcon name="creditCard" />
        <StyledCardNumberElement onChange={handleCardNumberChange} onFocus={toggle} onBlur={toggle} />
      </FormInput.FieldSet>
      {error && <FormInput.SupportingText>{error}</FormInput.SupportingText>}
    </FormInput.Root>
  );
};

export default CardNumber;
